var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoVideoCv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.5L12.9519 6.10516C11.6236 5.20859 9.83301 6.1603 9.83301 7.76288V16M9.83301 22V24.1829C9.83301 25.7962 11.645 26.7456 12.9714 25.8272L24.8531 17.6014C25.9846 16.8181 26.0053 15.1527 24.8937 14.3415L21 11.5",
    stroke: "#70758F",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 4L4.5 27",
    stroke: "#70758F",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideoCv);
export default __webpack_public_path__ + "static/media/no-video-cv.6a66a2e7efe8bbed02bb819b9e68a5b3.svg";
export { ForwardRef as ReactComponent };